import { useState, useEffect } from 'react'
import supabase from '../supabase/supabase'
import { getProfile, upsertProfile } from '../supabase/api'

export function useAuth() {
  const [user, setUser] = useState(null)
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
      if (session?.user) {
        loadProfile(session.user)
      } else {
        setLoading(false)
      }
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
      if (session?.user) {
        loadProfile(session.user)
      } else {
        setProfile(null)
        setLoading(false)
      }
    })

    return () => subscription.unsubscribe()
  }, [])

  const loadProfile = async (authUser) => {
    try {
      // First attempt to grab the existing profile
      let p = await getProfile(authUser.id).catch(() => null)
      
      // If it doesn't exist, this is their first time logging in (or email just got confirmed)
      // Create it dynamically using the metadata we saved during signUp
      if (!p) {
        p = await upsertProfile({
          id: authUser.id,
          email: authUser.email?.trim().toLowerCase() || '',
          role: authUser.user_metadata?.role || 'disciple', // fallback to disciple
          name: authUser.user_metadata?.name || ''
        })
      }
      
      setProfile(p)
    } catch (err) {
      console.error('Failed to load/create profile:', err)
      setProfile(null)
    } finally {
      setLoading(false)
    }
  }

  return { user, profile, loading, refetchProfile: () => user && loadProfile(user) }
}